import React from "react";
// import Illustration from "../../assets/illustration.svg";
import DisplayLottie from "./DisplayLottie";
import headerSvg from "../../assets/header-svg.json";
import "./home.scss";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { HashLink } from "react-router-hash-link";

const Home = () => {
  return (
    <div id="home" className="home">
      <div className="hero-text">
        <AnimationOnScroll animateIn="fadeInUp">
          <div className="main-title ">
            <div animateIn="fadeInUp">
              Hi, <br />
            </div>
            <div className="typing ">I'm Daniel Tolla.</div>
          </div>
        </AnimationOnScroll>
        <AnimationOnScroll animateIn="fadeInUp" delay={0.7 * 1000}>
          <div className="main-subtitle ">
            <p>FullStack Web Developer</p>{" "}
          </div>
        </AnimationOnScroll>
        <AnimationOnScroll animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">
            I'm a software engineer who specializes in web development.
          </p>
        </AnimationOnScroll>

        {/* <AnimationOnScroll animateIn="animate__pulse" delay={0.8 * 1000}> */}
        <HashLink smooth to="#contact" className="button">
          Hire Me
        </HashLink>
        {/* </AnimationOnScroll> */}
      </div>
      <div className="hero-image ">
        <AnimationOnScroll animateIn="animate__fadeInRight" delay={0.7 * 1000}>
          {/* <img src={Illustration} alt="Illustration" /> */}
          <DisplayLottie animationData={headerSvg} />
        </AnimationOnScroll>
      </div>
    </div>
  );
};

export default Home;
